import "react-datepicker/dist/react-datepicker.css";
import { Button } from "../../Button";
import { Container, Row, Col } from "react-grid-system";
import { getUpperUnitList } from "../../../api/unit/upper-unit";
import SimpleSearch from "../../SimpleSearch";
import {
	StyledAddUpperUnitIcon,
	StyledAddUpperUnitOptions,
	StyledAddUpperUnitActions,
} from "../../../styles/StyledAddUpperUnit/StyledAddUpperUnit";
import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import AddIcon from "../../../assets/img/icons/add.svg";
import icon from "../../../assets/img/upper-decision.png";
import PropTypes from "prop-types";
import { useUnitContext } from "../../../context/unitContext";
import { getUnitsList } from "../../../api/unit/unit";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { SelectableSingleUnits } from "../../SelectableLists/SelectableUnits";
import { getUserUnitsList } from "../../../api/organization-unit/organization-unit";
export default function AddUpperUnit({ onClick, unit, selectedUpperUnit, isNew }) {
	const { id } = useUnitContext();
	const { axiosPrivate } = useAxiosPrivate();

	const [unitSelectedID, setUnitSelectedID] = useState(null);
	const [phrase, setPhrase] = useState(null);
	const [searchValue, setSearchValue] = useState("");

	const handlePhraseChange = (newPhrase) => {
		setPhrase(newPhrase);
		setSearchValue(newPhrase);
	};

	const { data, isLoading, isError, error } = useQuery(["unit-id", phrase, id], () =>
		!isNew ? getUpperUnitList(axiosPrivate, id, phrase) : getUserUnitsList(axiosPrivate)
	);
	const [resultData, setResultData] = useState([]);

	useEffect(() => {
		if (!isLoading && !isError) {
			if (!isNew) {
				setResultData(data);
			} else {
				// For new units, filter the user's units based on the search phrase
				let filteredData = data || [];
				if (phrase && phrase.trim()) {
					const searchTerm = phrase.toLowerCase().trim();
					filteredData = data.filter(unit =>
						unit.name.toLowerCase().includes(searchTerm) ||
						(unit.description && unit.description.toLowerCase().includes(searchTerm))
					);
				}
				setResultData(filteredData);
			}
		}
	}, [isLoading, data, phrase, isNew]);

	const AddUnit = () => {
		const upperUnit = resultData.filter((el) => {
			if (el.id == unitSelectedID) {
				return el;
			}
		});
		selectedUpperUnit(upperUnit[0]);
		onClick();
	};

	return (
		<>
			<Container>
				<Row>
					<Col sm={2}>
						<StyledAddUpperUnitIcon>
							<img src={icon} alt="" />
						</StyledAddUpperUnitIcon>
					</Col>
					<Col sm={10}>
						<StyledAddUpperUnitOptions>
							<Row>
								<Col>
									<SimpleSearch
										isWhite
										value={searchValue}
										onChange={handlePhraseChange}
									/>
								</Col>
							</Row>
							<Button
								onClick={() => {
									setPhrase(null);
									setSearchValue("");
								}}
								bg={false}
								small={true}
							>
								Clear filters
							</Button>
						</StyledAddUpperUnitOptions>
					</Col>
				</Row>
				<Row>
					<Col>
						<SelectableSingleUnits
							data={resultData}
							isLoading={isLoading}
							isError={isError}
							error={error}
							unit={unit}
							setUnitSelectedID={setUnitSelectedID}
						/>
					</Col>
				</Row>
				<Row>
					<Col>
						<StyledAddUpperUnitActions>
							<Button onClick={onClick} bg={false} small={true}>
								Cancel
							</Button>
							<Button icon={AddIcon} onClick={AddUnit}>
								Add upper unit
							</Button>
						</StyledAddUpperUnitActions>
					</Col>
				</Row>
			</Container>
		</>
	);
}

AddUpperUnit.propTypes = {
	onClick: PropTypes.func,
	selectedUpperUnit: PropTypes.func,
	unit: PropTypes.object,
	matters: PropTypes.array,
	isNew: PropTypes.bool,
};

AddUpperUnit.defaultProps = {
	isNew: false,
};
